export default __webpack_public_path__ + "static/media/itto-poster.36b4bfce.jfif";